export const stringLimiter = (string: string) => {
  let limited_string;
  if (string.length > 20) {
    limited_string = string.substring(0, 20) + "..."
  } else {
    limited_string = string
  }
  return limited_string
}
